export default "__VITE_ASSET__DoRSXueK__"